webpackJsonp([1],Array(41).concat([
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popUp_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58cfbbcd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popUp_vue__ = __webpack_require__(192);
function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58cfbbcd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_defaultLayout__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_authLayout__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_messaging__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: {
    defaultLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_defaultLayout__["a" /* default */],
    authLayout: __WEBPACK_IMPORTED_MODULE_1__layouts_authLayout__["a" /* default */]
  },
  computed: {
    component: function component() {
      var route = this.$route;
      if (route.name === 'auth') {
        return __WEBPACK_IMPORTED_MODULE_1__layouts_authLayout__["a" /* default */];
      }
      return __WEBPACK_IMPORTED_MODULE_0__layouts_defaultLayout__["a" /* default */];
    }
  },
  data: function data() {
    return {
      snackbarTimeout: 3000,
      snackbar: false,
      snackbarText: '',
      snackbarColor: ''
    };
  },

  methods: {
    _showNetworkStatus: function _showNetworkStatus(_ref) {
      var type = _ref.type;

      if (type === 'online') {
        this.snackbarText = 'back ONLINE';
        this.snackbarColor = 'green';
      } else {
        this.snackbarText = 'working OFFLINE';
        this.snackbarColor = 'red';
      }
      this.snackbar = true;
    },
    promptToInstall: function promptToInstall(event) {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      event.preventDefault();
      // Show the prompt
      event.prompt();
      // Wait for the user to respond to the prompt
      event.userChoice.then(function (choiceResult) {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('offline', this._showNetworkStatus);
    window.addEventListener('online', this._showNetworkStatus);
    window.addEventListener('beforeinstallprompt', function (e) {
      _this.promptToInstall(e);
    });
    var messaging = __WEBPACK_IMPORTED_MODULE_2__firebase_app___default.a.messaging();
    // [START receive_message]
    // Handle incoming messages. Called when:
    // - a message is received while the app has focus
    // - the user clicks on an app notification created by a service worker
    //   `messaging.setBackgroundMessageHandler` handler.
    messaging.onMessage(function (payload) {
      console.log('Message received. ', payload);
      // [START_EXCLUDE]
      // Update the UI to include the received message.
      // appendMessage(payload);
      // [END_EXCLUDE]
    });
    // [END receive_message]
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'defaultLayout',
  data: function data() {
    return {
      drawer: false,
      fixed: false,
      actions: [{
        icon: 'mdi-map-marker-circle',
        title: 'Explore',
        link: { name: 'meetups' }
      }, {
        icon: 'add_circle_outline',
        title: 'Create Meetup',
        link: { name: 'myMeetups' }
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      searching: false,
      search: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    isAuthenticated: 'isAuthenticated',
    user: 'getUser'
  }), {
    showMenuIcon: function showMenuIcon() {
      var classes = '';
      classes += this.searching ? 'hidden-xs-only ' : '';
      classes += this.drawer ? 'hidden-lg-and-up ' : '';
      return classes;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['signOutUser']), {
    onBlur: function onBlur() {
      this.searching = false;
      this.search = '';
    },
    searchBegin: function searchBegin() {
      this.searching = true;
      setTimeout(function () {
        return document.querySelector('#search').focus();
      }, 50);
    },
    searchEnd: function searchEnd() {
      this.searching = false;
      this.search = '';
      document.querySelector('#search').blur();
    },
    onSignIn: function onSignIn() {
      this.$router.push({ name: 'auth', query: { redirect: this.$route.fullPath } });
    },
    onLogout: function onLogout() {
      var _this = this;

      this.signOutUser().then(function (res) {
        _this.$router.push({ name: 'home' });
      }).catch(function (err) {
        alert('failed to Logout, ' + err);
      });
    },
    navigateToHome: function navigateToHome() {
      this.$router.push({ name: 'home' });
    }
  })
});

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'authLayout'
});

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_meetups_meetupCard__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_meetups_meetupDetails__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import depthCard from '@/components/shared/depthCard'





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    allMeetups: 'getMeetups'
  }), {
    totalMeetups: function totalMeetups() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.allMeetups).length;
    },
    featuredMeetups: function featuredMeetups() {
      var _this = this;

      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.allMeetups);
      if (keys.length < 6) {
        return keys.map(function (key) {
          return _this.allMeetups[key];
        });
      } else {
        var featured = [];
        for (var i = 0; i < 6; i++) {
          featured.push(this.allMeetups[keys[i]]);
        }
        return featured;
      }
    }
  }),
  data: function data() {
    return {
      icons: ['fab fa-facebook', 'fab fa-twitter', 'fab fa-google-plus', 'fab fa-linkedin', 'fab fa-instagram'],
      meetupDetailsDialog: false,
      meetup: {
        title: '',
        coverPicURL: '',
        description: '',
        date: null,
        time: null,
        location: '',
        category: '',
        user: {
          photoURL: '',
          displayName: '',
          email: ''
        }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['fetchAllMeetups']), {
    onShowDetails: function onShowDetails(meetup) {
      console.log('called showDetails for: ', meetup);
      this.meetup = meetup;
      this.meetupDetailsDialog = true;
    },
    closeMeetupDetails: function closeMeetupDetails() {
      this.meetupDetailsDialog = false;
    }
  }),
  components: {
    meetupCard: __WEBPACK_IMPORTED_MODULE_2__components_meetups_meetupCard__["a" /* default */],
    meetupDetails: __WEBPACK_IMPORTED_MODULE_3__components_meetups_meetupDetails__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Slide"]
  },
  created: function created() {
    this.fetchAllMeetups().then(function (res) {}).catch(function (error) {
      alert('Could not fetch meetups, ' + error);
    });
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_meetupCard_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22918cab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_meetupCard_vue__ = __webpack_require__(181);
function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_meetupCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22918cab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_meetupCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'meetup',
  props: {
    meetup: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    color: function color() {
      return 'orange';
    }
  },
  methods: {}
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_meetupDetails_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_644e3f58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_meetupDetails_vue__ = __webpack_require__(183);
function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_meetupDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_644e3f58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_meetupDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'meetup-details',
  props: {
    dialog: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    meetup: {
      type: Object,
      default: function _default() {
        return {
          title: '',
          coverPicURL: '',
          description: '',
          date: null,
          time: null,
          location: '',
          category: '',
          user: {
            photoURL: '',
            displayName: '',
            email: ''
          }
        };
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    isAuthenticated: 'isAuthenticated'
  }), {
    totalGoing: function totalGoing() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.goingUsers).length;
    },
    color: function color() {
      return 'orange';
    }
  }),
  data: function data() {
    return {
      active: null,
      going: false,
      goingUsers: {}
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['updateGoingStatus', 'isGoing', 'fetchAllGoingUsers']), {
    onClose: function onClose() {
      this.$emit('close');
    },
    onChangeGoing: function onChangeGoing(event) {
      console.log('change: ', event);
      this.updateGoingStatus({ meetup: this.meetup, status: event });
      this.setGoingUsers();
    },
    setGoingStatus: function setGoingStatus() {
      var _this = this;

      this.isGoing(this.meetup).then(function (res) {
        console.log('gonig: ', res);
        _this.going = res;
      });
    },
    setGoingUsers: function setGoingUsers() {
      var _this2 = this;

      this.fetchAllGoingUsers(this.meetup).then(function (users) {
        _this2.goingUsers = users;
      }).catch(function (error) {
        console.log('error: ', error);
      });
    }
  }),
  watch: {
    dialog: function dialog(value) {
      if (value) {
        this.setGoingStatus();
        this.setGoingUsers();
      }
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_auth_signIn__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_signUp__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_forgotPassword__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'auth',
  data: function data() {
    return {
      active: null
    };
  },

  components: {
    signIn: __WEBPACK_IMPORTED_MODULE_1__components_auth_signIn__["a" /* default */],
    signUp: __WEBPACK_IMPORTED_MODULE_2__components_auth_signUp__["a" /* default */],
    forgotPassword: __WEBPACK_IMPORTED_MODULE_3__components_auth_forgotPassword__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['isAuthenticated'])),
  methods: {
    onSignUpSuccess: function onSignUpSuccess() {
      this.active = 0;
    },
    onSignInSuccess: function onSignInSuccess() {
      this.redirect();
    },
    redirect: function redirect() {
      var redirectPath = this.$route.query.redirect;
      // console.log('redirect path: ', redirectPath)
      if (redirectPath) {
        this.$router.push({ path: redirectPath });
      } else {
        this.$router.push({ name: 'home' });
      }
    }
  },
  watch: {
    isAuthenticated: function isAuthenticated(value) {
      if (value) {
        this.redirect();
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    console.log('beforeEnter to: ', to);
    console.log('beforeEnter from: ', from);
    next(function (vm) {
      console.log('auth state: ', vm.$store.getters.isAuthenticated);
      if (vm.$store.getters.isAuthenticated) {
        next({ name: 'home' });
      }
    });
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_popUp__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'singIn',
  data: function data() {
    return {
      email: '',
      password: '',
      loading: false,
      passVisible: false,
      showPopUp: false,
      popUpBody: '',
      popUpColor: 'primary',
      popUpTitle: '',
      popUpButons: [{
        icon: '',
        text: 'OK',
        action: 'okay',
        color: 'primary',
        flat: false
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['signInUser']), {
    onSignIn: function onSignIn() {
      var _this = this;

      this.loading = true;
      this.signInUser({ email: this.email, password: this.password }).then(function (user) {
        _this.$emit('signInSuccess');
      }).catch(function (err) {
        _this.popUpColor = 'red';
        _this.popUpTitle = 'error';
        _this.popUpButons = [{
          icon: '',
          text: 'OK',
          action: 'signInError',
          color: 'red',
          flat: false
        }];
        _this.popUpBody = 'could not signIn, ' + err;
        _this.showPopUp = true;
      }).then(function () {
        _this.loading = false;
      });
    },
    closePopUp: function closePopUp() {
      this.showPopUp = false;
    }
  }),
  components: {
    popUp: __WEBPACK_IMPORTED_MODULE_1__components_shared_popUp__["a" /* default */]
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'popUp',
  props: {
    buttons: {
      type: Array,
      default: function _default() {
        return [{
          icon: '',
          text: 'OK',
          action: 'okay',
          color: 'primary',
          flat: false
        }];
      }
    },
    dialog: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    title: {
      type: String,
      default: function _default() {
        return 'Alert';
      }
    },
    color: {
      type: String,
      default: function _default() {
        return 'primary';
      }
    },
    body: {
      type: String,
      default: function _default() {
        return 'Something went WRONG!!';
      }
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onButtonClick: function onButtonClick(action, index) {
      // console.log('buttons: ', this.buttons)
      // console.log('button action: ', action)
      // console.log('button index: ', index)
      this.$emit(action);
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_popUp__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signUp',
  data: function data() {
    return {
      fullName: '',
      email: '',
      password: '',
      passVisible: false,
      // confirmPassword: '',
      loading: false,
      showPopUp: false,
      popUpBody: '',
      popUpColor: 'primary',
      popUpTitle: '',
      popUpButons: [{
        icon: '',
        text: 'OK',
        action: 'okay',
        color: 'primary',
        flat: false
      }]
    };
  },

  computed: {
    // comparePasswords () {
    //   return this.password === this.confirmPassword ? true : 'Passwords do not match'
    // }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['createNewUser']), {
    onSignUp: function onSignUp() {
      var _this = this;

      this.loading = true;
      this.createNewUser({ email: this.email, password: this.password, fullName: this.fullName }).then(function (res) {
        _this.popUpColor = 'primary';
        _this.popUpTitle = 'signed Up';
        _this.popUpButons = [{
          icon: '',
          text: 'OK',
          action: 'signUpSuccess',
          color: 'primary',
          flat: false
        }];
        _this.popUpBody = 'A email verification has been sent to your email address (' + _this.email + '). Verify your email before signing in.';
      }).catch(function (err) {
        _this.popUpColor = 'red';
        _this.popUpTitle = 'error';
        _this.popUpButons = [{
          icon: '',
          text: 'OK',
          action: 'signUpError',
          color: 'red',
          flat: false
        }];
        _this.popUpBody = 'could not signUp, ' + err;
      }).then(function () {
        _this.loading = false;
        _this.showPopUp = true;
      });
    },
    onSignUpSuccess: function onSignUpSuccess() {
      this.$emit('signUpSuccess');
      this.closePopUp();
      this.onClear();
    },
    closePopUp: function closePopUp() {
      this.showPopUp = false;
    },
    onClear: function onClear() {
      this.fullName = '';
      this.email = '';
      this.password = '';
    }
  }),
  components: {
    popUp: __WEBPACK_IMPORTED_MODULE_1__components_shared_popUp__["a" /* default */]
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_popUp__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forgotPassword',
  data: function data() {
    return {
      email: '',
      loading: false,
      showPopUp: false,
      popUpBody: '',
      popUpColor: 'primary',
      popUpTitle: '',
      popUpButons: [{
        icon: '',
        text: 'OK',
        action: 'okay',
        color: 'primary',
        flat: false
      }]
    };
  },

  components: {
    popUp: __WEBPACK_IMPORTED_MODULE_1__shared_popUp__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['sendPasswordResetLink']), {
    onResetPassword: function onResetPassword() {
      var _this = this;

      this.loading = true;
      this.sendPasswordResetLink({ email: this.email }).then(function (res) {
        _this.popUpColor = 'primary';
        _this.popUpTitle = 'signed Up';
        _this.popUpButons = [{
          icon: '',
          text: 'OK',
          action: 'okay',
          color: 'primary',
          flat: false
        }];
        _this.popUpBody = 'A password reset link has been set to your email (' + _this.email + ').';
      }).catch(function (err) {
        _this.popUpColor = 'red';
        _this.popUpTitle = 'error';
        _this.popUpButons = [{
          icon: '',
          text: 'OK',
          action: 'okay',
          color: 'red',
          flat: false
        }];
        _this.popUpBody = '' + err;
      }).then(function () {
        _this.showPopUp = true;
        _this.loading = false;
      });
    },
    closePopUp: function closePopUp() {
      this.showPopUp = false;
    }
  })
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FileUpload__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_storage__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    user: 'getUser'
  })),
  data: function data() {
    return {
      loading: false,
      disabled: false,
      displayName: '',
      photoURL: '',
      email: '',
      uploadProgress: 0,
      showUploadProgress: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['updateUserProfile', 'autoSignIn']), {
    onSubmit: function onSubmit() {
      var _this = this;

      var profile = {
        displayName: this.displayName,
        email: this.email,
        photoURL: this.photoURL
      };
      this.loading = true;
      this.updateUserProfile(profile).then(function (res) {
        // console.log('profile updated successfully.')
        _this.autoSignIn();
        _this.redirect();
      }).catch(function (error) {
        console.log('error updating profile, ', error);
      }).then(function () {
        _this.loading = false;
      });
    },
    redirect: function redirect() {
      this.$router.push({ name: 'home' });
    },
    uploadProfilePic: function uploadProfilePic(file) {
      var _this2 = this;

      // console.log('called uploadProfilePic: ', file)
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        // console.log('base64: ', fileReader.result)
        _this2.photoURL = fileReader.result;
      });
      fileReader.readAsDataURL(file);
      // this.uploadMeetupCover(file)
      var myApp = this;
      // Create a root reference
      var storageRef = __WEBPACK_IMPORTED_MODULE_2__firebase_app___default.a.storage().ref();
      myApp.disabled = true;
      // Upload file and metadata to the object 'images/mountains.jpg'
      var uploadTask = storageRef.child(myApp.user.id + '/profilePic/' + file.name).put(file);
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(__WEBPACK_IMPORTED_MODULE_2__firebase_app___default.a.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      function (snapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        myApp.showUploadProgress = true;
        myApp.uploadProgress = Math.floor(progress);
        // console.log('Upload is ' + progress + '% done')
        switch (snapshot.state) {
          case __WEBPACK_IMPORTED_MODULE_2__firebase_app___default.a.storage.TaskState.PAUSED:
            // or 'paused'
            console.log('Upload is paused');
            break;
          case __WEBPACK_IMPORTED_MODULE_2__firebase_app___default.a.storage.TaskState.RUNNING:
            // or 'running'
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        myApp.disabled = false;
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/unauthorized':
            console.log('User doesn\'t have permission to access the object');
            break;
          case 'storage/canceled':
            console.log('User canceled the upload');
            break;
          case 'storage/unknown':
            console.log('Unknown error occurred, inspect error.serverResponse');
            break;
        }
      }, function () {
        myApp.disabled = false;
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          myApp.photoURL = downloadURL;
        });
      });
    }
  }),
  created: function created() {
    this.displayName = this.user.displayName;
    this.photoURL = this.user.photoURL;
    this.email = this.user.email;
  },

  components: {
    FileUpload: __WEBPACK_IMPORTED_MODULE_1__components_shared_FileUpload__["a" /* default */]
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // console.log('beforeEnter to: ', to)
    // console.log('beforeEnter from: ', from)
    next(function (vm) {
      // console.log('auth state: ', vm.$store.getters.isAuthenticated)
      if (!vm.$store.getters.isAuthenticated) {
        next({ name: 'auth' });
      }
    });
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9df54e22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__ = __webpack_require__(204);
function injectStyle (ssrContext) {
  __webpack_require__(203)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9df54e22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9df54e22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'file-upload',
  data: function data() {
    return {
      snackbarTimeout: 2000,
      snackbarColor: 'error',
      snackbar: false,
      snackbarText: '',
      file: null,
      filename: ''
    };
  },

  props: {
    required: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    label: {
      type: String,
      default: function _default() {
        return 'Choose File';
      }
    }
  },
  methods: {
    onFocus: function onFocus() {
      this.$refs.fileInput.click();
    },
    onFileChange: function onFileChange(event) {
      var files = event.target.files || event.dataTransfer.files;
      this.file = files[0];
      this.filename = this.file.name;
      this.uploadFile();
      // if (!files.length) {
      //   return;
      // }
      // this.createImage(files[0]);
    },
    uploadFile: function uploadFile() {
      console.log('UploadFile: ', this.file);
      if (this.file) {
        this.$emit('uploadFile', this.file);
      } else {
        this.snackbarTimeout = 3000;
        this.snackbarColor = 'error';
        this.snackbar = true;
        this.snackbarText = 'Please select a file to upload';
      }
    }
    // createImage (file) {
    //   var image = new Image();
    //   var reader = new FileReader();
    //   var vm = this;

    //   reader.onload = (e) => {
    //     vm.image = e.target.result;
    //   };
    //   reader.readAsDataURL(file);
    // },

  }
});

/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_meetups_meetupCard__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_meetups_meetupDetails__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'meetups',
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    meetups: 'getMeetups',
    categories: 'getMeetupCategories'
  }), {
    totalMeetups: function totalMeetups() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.meetups).length;
    }
  }),
  data: function data() {
    return {
      meetupDetailsDialog: false,
      meetup: {
        title: '',
        coverPicURL: '',
        description: '',
        date: null,
        time: null,
        location: '',
        category: '',
        user: {
          photoURL: '',
          displayName: '',
          email: ''
        }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['fetchAllMeetups']), {
    onShowDetails: function onShowDetails(meetup) {
      console.log('called showDetails for: ', meetup);
      this.meetup = meetup;
      this.meetupDetailsDialog = true;
    },
    closeMeetupDetails: function closeMeetupDetails() {
      this.meetupDetailsDialog = false;
    }
  }),
  components: {
    meetupCard: __WEBPACK_IMPORTED_MODULE_2__components_meetups_meetupCard__["a" /* default */],
    meetupDetails: __WEBPACK_IMPORTED_MODULE_3__components_meetups_meetupDetails__["a" /* default */]
  },
  created: function created() {
    this.fetchAllMeetups().then(function (res) {}).catch(function (error) {
      alert('Could not fetch meetups, ' + error);
    });
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_meetups_createEditMeetup__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_meetups_myMeetupCard__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'myMeetups',
  data: function data() {
    return {
      createEditDialog: false,
      createEditDialogMode: 'Create',
      loading: false,
      meetup: {
        title: '',
        coverPicURL: '',
        description: '',
        date: null,
        time: null,
        location: '',
        category: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    myMeetups: 'getMyMeetups'
  }), {
    totalMeetups: function totalMeetups() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.myMeetups).length;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['createNewMeetup', 'updateExistingMeetup', 'fetchMyMeetups', 'deleteMeetup']), {
    updateMeetup: function updateMeetup(meetup) {
      var _this = this;

      console.log('updateMeetup: ', meetup);
      this.loading = true;
      this.updateExistingMeetup(meetup).then(function (res) {
        alert('Meetup was successfully updated.');
        _this.closeCreateEditDialog();
      }).catch(function (error) {
        alert('Failed to update meetup, ' + error);
      }).then(function () {
        _this.loading = false;
      });
    },
    onDeleteMeetup: function onDeleteMeetup(meetup) {
      if (confirm('Are you sure you want to delete: ' + meetup.title)) {
        this.deleteMeetup(meetup).then(function (res) {
          alert('Meetup successfully deleted.');
        }).catch(function (error) {
          alert('Failed to delete meetup, ' + error);
        });
      }
    },
    createMeetup: function createMeetup(meetup) {
      var _this2 = this;

      console.log('createMeetup: ', meetup);
      this.loading = true;
      this.createNewMeetup(meetup).then(function (res) {
        alert('Meetup was successfully created.');
        _this2.closeCreateEditDialog();
      }).catch(function (error) {
        alert('Failed to create meetup, ' + error);
      }).then(function () {
        _this2.loading = false;
      });
    },
    onEdit: function onEdit(meetup) {
      this.showCreateEditDialog('Edit', meetup);
    },
    showCreateEditDialog: function showCreateEditDialog(mode, meetup) {
      // console.log('dialog mode: ', mode)
      if (mode === 'Edit') {
        this.createEditDialogMode = 'Edit';
        this.meetup = meetup;
      } else {
        this.createEditDialogMode = 'Create';
        this.meetup = {
          title: '',
          coverPicURL: '',
          description: '',
          date: null,
          time: null,
          location: '',
          category: ''
        };
      }
      this.createEditDialog = true;
    },
    closeCreateEditDialog: function closeCreateEditDialog() {
      this.createEditDialog = false;
    }
  }),
  components: {
    createEditMeetup: __WEBPACK_IMPORTED_MODULE_2__components_meetups_createEditMeetup__["a" /* default */],
    myMeetupCard: __WEBPACK_IMPORTED_MODULE_3__components_meetups_myMeetupCard__["a" /* default */]
  },
  created: function created() {
    this.fetchMyMeetups().then(function (res) {}).catch(function (error) {
      // alert('Could not fetch your meetups, ' + error)
      console.log('Could not fetch your meetups, ' + error);
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    console.log('beforeEnter to: ', to);
    console.log('beforeEnter from: ', from);
    next(function (vm) {
      console.log('auth state: ', vm.$store.getters.isAuthenticated);
      if (!vm.$store.getters.isAuthenticated) {
        next({ name: 'auth' });
      }
    });
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FileUpload__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_storage__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'create-edit-meetup-dialog',
  props: {
    dialog: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    mode: {
      type: String,
      default: function _default() {
        return 'Create';
      }
    },
    loading: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    meetup: {
      type: Object,
      default: function _default() {
        return {
          title: '',
          coverPicURL: '',
          description: '',
          date: null,
          time: null,
          location: '',
          category: ''
        };
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    categories: 'getMeetupCategories'
  }), {
    submitBtnText: function submitBtnText() {
      return this.mode === 'Edit' ? 'Update' : 'Create';
    },
    incomplete: function incomplete() {
      if (this.meetup.title && this.meetup.description && this.meetup.date && this.meetup.time && this.meetup.location && this.meetup.category) {
        return false;
      } else {
        return true;
      }
    }
  }),
  data: function data() {
    return {
      disabled: false,
      // title: '',
      // coverPicURL: '',
      // description: '',
      // date: null,
      // time: null,
      // location: '',
      // category: '',
      dateDialog: false,
      timeDialog: false,
      uploadProgress: 0,
      showUploadProgress: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['uploadMeetupCover']), {
    onSubmit: function onSubmit() {
      // var meetup = {
      //   title: this.title,
      //   location: this.location,
      //   description: this.description,
      //   date: this.date,
      //   time: this.time,
      //   coverPicURL: this.coverPicURL,
      //   category: this.category
      // }
      // console.log('mode: ', this.mode)
      // console.log('meetup: ', meetup)
      if (this.mode === 'Edit') {
        this.$emit('updateMeetup', this.meetup);
      } else {
        this.$emit('createMeetup', this.meetup);
      }
    },
    uploadCover: function uploadCover(file) {
      var _this = this;

      console.log('called uploadCover: ', file);
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this.meetup.coverPicURL = fileReader.result;
      });
      fileReader.readAsDataURL(file);
      // this.uploadMeetupCover(file)
      var myApp = this;
      // Create a root reference
      var storageRef = __WEBPACK_IMPORTED_MODULE_2__firebase_app___default.a.storage().ref();
      myApp.disabled = true;
      // Upload file and metadata to the object 'images/mountains.jpg'
      var uploadTask = storageRef.child(myApp.user.id + '/meetups/' + file.name).put(file);
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(__WEBPACK_IMPORTED_MODULE_2__firebase_app___default.a.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      function (snapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        myApp.showUploadProgress = true;
        myApp.uploadProgress = Math.floor(progress);
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case __WEBPACK_IMPORTED_MODULE_2__firebase_app___default.a.storage.TaskState.PAUSED:
            // or 'paused'
            console.log('Upload is paused');
            break;
          case __WEBPACK_IMPORTED_MODULE_2__firebase_app___default.a.storage.TaskState.RUNNING:
            // or 'running'
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        myApp.disabled = false;
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/unauthorized':
            console.log('User doesn\'t have permission to access the object');
            break;
          case 'storage/canceled':
            console.log('User canceled the upload');
            break;
          case 'storage/unknown':
            console.log('Unknown error occurred, inspect error.serverResponse');
            break;
        }
      }, function () {
        myApp.disabled = false;
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          console.log('downloadURL: ', downloadURL);
          myApp.meetup.coverPicURL = downloadURL;
        });
      });
    },
    onClose: function onClose() {
      this.$emit('close');
    }
  }),
  components: {
    FileUpload: __WEBPACK_IMPORTED_MODULE_1__components_shared_FileUpload__["a" /* default */]
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-meetup-card',
  props: {
    meetup: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    onEdit: function onEdit() {
      this.$emit('onEdit', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.meetup));
    },
    onDelete: function onDelete() {
      this.$emit('onDelete', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.meetup));
    }
  },
  computed: {
    color: function color() {
      return 'orange';
    }
  }
});

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_firebaseConfig__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_Vuetify__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_Vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_Vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VApp__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VNavigationDrawer__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VNavigationDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VNavigationDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VFooter__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VList__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VBtn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VIcon__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VGrid__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VToolbar__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_transitions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_transitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VCard__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VTooltip__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VSubheader__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VTextField__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VAvatar__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VAvatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VAvatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VBadge__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VDivider__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VDivider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VDivider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VTabs__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VDialog__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VDatePicker__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VDatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VDatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTimePicker__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VSnackbar__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VSnackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VSnackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VProgressCircular__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VProgressCircular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VProgressCircular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VSelect__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VSwitch__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VCarousel__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VCarousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__node_modules_vuetify_src_stylus_app_styl__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__node_modules_vuetify_src_stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__node_modules_vuetify_src_stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_dist_vuetify_min_css__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__firebase_firestore__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__firebase_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__firebase_auth__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__firebase_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__firebase_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__firebase_messaging__ = __webpack_require__(74);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








































__WEBPACK_IMPORTED_MODULE_4__firebase_app___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_5__config_firebaseConfig__["a" /* config */]);
var db = __WEBPACK_IMPORTED_MODULE_4__firebase_app___default.a.firestore();
var settings = {
  timestampsInSnapshots: true
};
db.settings(settings);
db.enablePersistence().then(function () {
  console.log('persistence mode enabled.');
}).catch(function (err) {
  if (err.code === 'failed-precondition') {
    // Multiple tabs open, persistence can only be enabled
    // in one tab at a a time.
    // ...
  } else if (err.code === 'unimplemented') {
    // The current browser does not support all of the
    // features required to enable persistence
    // ...
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_Vuetify___default.a, {
  components: {
    VApp: __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VApp___default.a,
    VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VNavigationDrawer___default.a,
    VFooter: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VFooter___default.a,
    VList: __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VList___default.a,
    VBtn: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VBtn___default.a,
    VIcon: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VIcon___default.a,
    VGrid: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VGrid___default.a,
    VToolbar: __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VToolbar___default.a,
    transitions: __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_transitions___default.a,
    VCard: __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VCard___default.a,
    VTooltip: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VTooltip___default.a,
    VMenu: __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu___default.a,
    VSubheader: __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VSubheader___default.a,
    VTextField: __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VTextField___default.a,
    VAvatar: __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VAvatar___default.a,
    VBadge: __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VBadge___default.a,
    VDivider: __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VDivider___default.a,
    VTabs: __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VTabs___default.a,
    VDialog: __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VDialog___default.a,
    VDatePicker: __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VDatePicker___default.a,
    VTimePicker: __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTimePicker___default.a,
    VSnackbar: __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VSnackbar___default.a,
    VProgressCircular: __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VProgressCircular___default.a,
    VSelect: __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VSelect___default.a,
    VSwitch: __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VSwitch___default.a,
    VCarousel: __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VCarousel___default.a
    // theme: {
    //   primary: '#ee44aa',
    //   secondary: '#424242',
    //   accent: '#82B1FF',
    //   error: '#FF5252',
    //   info: '#2196F3',
    //   success: '#4CAF50',
    //   warning: '#FFC107'
    // }
  } });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
var unsubscribe = __WEBPACK_IMPORTED_MODULE_4__firebase_app___default.a.auth().onAuthStateChanged(function (firebaseUser) {
  unsubscribe();
  // console.log('firebaseUser: ', firebaseUser)
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
    components: {
      App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
    },
    template: '<App/>',
    created: function created() {
      this.$store.dispatch('autoSignIn');
      var messaging = __WEBPACK_IMPORTED_MODULE_4__firebase_app___default.a.messaging();
      messaging.usePublicVapidKey('BBGVqGt8qLXooffdQx9j9pumI9SF-0lOEyQkOyAhGO_DOdAdOJL6-ZN8arf7Vft0lChgXU3jK12kMo9O8ZKsUvI');
      messaging.requestPermission().then(function () {
        console.log('Notification permission granted.');
        // TODO(developer): Retrieve an Instance ID token for use with FCM.
        // ...
      }).catch(function (err) {
        console.log('Unable to get permission to notify.', err);
      });
      window.addEventListener('beforeinstallprompt', function (event) {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        event.preventDefault();
        // Show the prompt
        event.prompt();
        // Wait for the user to respond to the prompt
        event.userChoice.then(function (choiceResult) {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
        });
      });
    }
  });
});

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b24d2d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(160);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b24d2d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_defaultLayout_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b38e68b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_defaultLayout_vue__ = __webpack_require__(156);
function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b38e68b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_defaultLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b38e68b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_defaultLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-navigation-drawer',{staticClass:"blue-grey darken-4",attrs:{"width":"250","dark":"","temporary":"","fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{staticClass:"transparent",attrs:{"flat":"","dense":""}},[_c('v-list',{staticClass:"pa-0"},[_c('v-list-tile',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.navigateToHome}},[_c('v-list-tile-action',[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{attrs:{"src":__webpack_require__(53)}})])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('h2',{staticClass:"app-title"},[_vm._v("Meetups")])])],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"subheader":""}},[_vm._l((_vm.actions),function(item){return [_c('v-list-tile',{key:item.icon,attrs:{"to":item.link,"exact":""}},[_c('v-list-tile-action',[_c('v-icon',{domProps:{"innerHTML":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)}})],1)],1)]})],2),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-toolbar',{attrs:{"app":"","flat":"","prominent":"","color":"primary","dark":""}},[_c('v-toolbar-side-icon',{staticClass:"hidden-sm-and-up",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',{staticClass:"mx-2",staticStyle:{"cursor":"pointer"},on:{"click":_vm.navigateToHome}},[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{attrs:{"src":__webpack_require__(53)}})]),_vm._v(" "),_c('span',{staticClass:"app-title hidden-xs-only"},[_c('b',[_vm._v("Meetups")])])],1),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-xs-only"},_vm._l((_vm.actions),function(item){return _c('v-btn',{key:item.title,attrs:{"flat":"","to":item.link}},[_c('small',[_c('v-icon',[_vm._v(_vm._s(item.icon))]),_vm._v("\n          "+_vm._s(item.title)+"\n        ")],1)])})),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isAuthenticated)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){$event.stopPropagation();_vm.rightDrawer = !_vm.rightDrawer}},slot:"activator"},[_c('v-badge',{attrs:{"color":"red","overlap":""}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("2")]),_vm._v(" "),_c('v-icon',[_vm._v("notifications")])],1)],1),_vm._v(" "),_c('span',[_vm._v("2 unread notifications")])],1):_vm._e(),_vm._v(" "),(_vm.isAuthenticated)?_c('v-menu',{attrs:{"bottom":"","offset-x":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-avatar',{staticClass:"white",attrs:{"size":"32"}},[(_vm.user.photoURL)?_c('img',{attrs:{"src":_vm.user.photoURL}}):_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("\n            person\n          ")])],1)],1),_vm._v(" "),_c('v-list',{staticClass:"pa-0"},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-avatar',{staticClass:"primary",attrs:{"size":"48px"}},[(_vm.user.photoURL)?_c('img',{attrs:{"src":_vm.user.photoURL}}):_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                person\n              ")])],1)],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.displayName))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.user.email))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{key:"profile",attrs:{"to":{name: 'profile'}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("My Profile")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{key:"lock",on:{"click":_vm.onLogout}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("lock")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Logout")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.isAuthenticated)?_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.onSignIn}},[_vm._v("\n      Sign In\n      "),_c('v-icon',{staticClass:"pl-2"},[_vm._v("mdi-login")])],1):_vm._e()],1),_vm._v(" "),_c('v-content',[_c('router-view')],1),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"temporary":"","right":_vm.right,"fixed":"","app":""},model:{value:(_vm.rightDrawer),callback:function ($$v) {_vm.rightDrawer=$$v},expression:"rightDrawer"}},[_c('v-toolbar',{staticClass:"primary",attrs:{"flat":"","prominent":"","dark":""}},[_c('v-toolbar-title',[_vm._v("Notifications")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.rightDrawer = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-list',{attrs:{"subheader":"","dense":""}},[_c('v-subheader',[_vm._v("All notifications")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',[_vm._v("person_add")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("\n          12 new users registered\n        ")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',[_vm._v("data_usage")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("\n          80% increase in popularity\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_authLayout_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_451d0a5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_authLayout_vue__ = __webpack_require__(159);
function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_authLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_451d0a5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_authLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.component,{tag:"component"},[_vm._t("default")],2),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarTimeout,"color":_vm.snackbarColor},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarText)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Dismiss")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__meetups__ = __webpack_require__(206);







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__home__["a" /* routes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__auth__["a" /* routes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__meetups__["a" /* routes */]))
});

// router.beforeEach((to, from, next) => {
//   console.log('inside beforeEach')
//   console.log('to: ', to.name)
//   console.log('from: ', from.name)
//   const isAuthenticated = store.getters.isAuthenticated
//   console.log('isAuthenticated: ', isAuthenticated)
//   if (to.matched.some(record => record.meta.anonymous)) {
//     console.log('user is already signed in...')
//     if (isAuthenticated) {
//       console.log('user is authenticated, going to home.')
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     console.log('authentication is required.')
//     if (isAuthenticated) {
//       console.log('user is authenticated, going to : ', next)
//       next()
//     } else {
//       console.log('trying to auto sign in')
//       store.dispatch('autoSignIn').then((currentUser) => {
//         // console.log('current user: ', currentUser)
//         if (currentUser) {
//           // console.log('user is present')
//           next()
//         } else {
//           // console.log('user is absent')
//           next({
//             name: 'auth',
//             query: {
//               redirect: to.fullPath
//             }
//           })
//         }
//       }).catch(() => {
//         console.log('an error occured in auto sign in.')
//         next({
//           name: 'signIn',
//           query: {
//             redirect: to.fullPath
//           }
//         })
//       })
//     }
//   } else {
//     next()
//   }
// })

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_home__ = __webpack_require__(175);


var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home__["a" /* default */],
  name: 'home'
}];

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fb144da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(185);
function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9fb144da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fb144da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-2"},[_c('v-card-media',{class:_vm.color,attrs:{"src":_vm.meetup.coverPicURL,"height":"125px"}}),_vm._v(" "),_c('v-subheader',[_vm._v("\n    "+_vm._s(_vm.meetup.date)+", "+_vm._s(_vm.meetup.location)+"\n  ")]),_vm._v(" "),_c('v-card-title',{staticClass:"pb-0 pt-1",attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.meetup.title))])])]),_vm._v(" "),_c('v-card-text',{staticClass:"pa-1"},[_c('v-list',{staticClass:"pt-0",attrs:{"three-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("\n          "+_vm._s(_vm.meetup.description)+"\n        ")])],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"pa-1"},[_c('v-list',{staticClass:"pt-0",attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-avatar',{staticClass:"primary",attrs:{"size":"32"}},[(_vm.meetup.user.photoURL)?_c('img',{attrs:{"src":_vm.meetup.user.photoURL}}):_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n              person\n            ")])],1)],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v("\n          by "),_c('b',[_vm._v(_vm._s(_vm.meetup.user.displayName))])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"scrollable":"","max-width":"800px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-media',{class:_vm.color,attrs:{"src":_vm.meetup.coverPicURL,"height":"200px"}}),_vm._v(" "),_c('v-tabs',{attrs:{"fixed-tabs":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab',{key:1,attrs:{"ripple":""}},[_vm._v("\n          Details\n        ")]),_vm._v(" "),_c('v-tab-item',{key:1},[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',[_vm._v(_vm._s(_vm.meetup.title))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.meetup.date)+", "+_vm._s(_vm.meetup.time)+"\n              ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('b',[_vm._v("@ ")]),_vm._v(_vm._s(_vm.meetup.location)+"\n              ")])],1)],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n            "+_vm._s(_vm.meetup.description)+"\n          ")]),_vm._v(" "),_c('v-card-text',{staticClass:"py-2"},[(_vm.isAuthenticated)?_c('v-switch',{attrs:{"label":"Going"},on:{"change":_vm.onChangeGoing},model:{value:(_vm.going),callback:function ($$v) {_vm.going=$$v},expression:"going"}}):_vm._e(),_vm._v(" "),_c('v-subheader',[_vm._v("\n              Created By\n            ")]),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',[(_vm.meetup.user.photoURL)?_c('img',{attrs:{"src":_vm.meetup.user.photoURL}}):_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                    person\n                  ")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('b',[_vm._v(_vm._s(_vm.meetup.user.displayName))]),_vm._v("\n                  "+_vm._s(_vm.meetup.user.email)+"\n                ")])],1)],1)],1)],1),_vm._v(" "),_c('v-tab',{key:2,attrs:{"ripple":""}},[_vm._v("\n          Going\n          "),(_vm.totalGoing > 0)?_c('v-badge',{attrs:{"color":"primary","small":""}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.totalGoing > 99 ? '99+' : _vm.totalGoing))])]):_vm._e()],1),_vm._v(" "),_c('v-tab-item',{key:2},[(_vm.totalGoing === 0)?_c('h3',[_vm._v("\n            No users going at the moment.\n          ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.goingUsers),function(user){return [_c('v-list-tile',{key:user.id},[_c('v-list-tile-avatar',[_c('v-avatar',{staticClass:"primary",attrs:{"size":"32"}},[(user.photoURL)?_c('img',{attrs:{"src":user.photoURL}}):_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                    person\n                  ")])],1)],1),_vm._v(" "),_c('v-list-tile-content',[_c('b',[_vm._v(_vm._s(user.displayName))]),_vm._v("\n                "+_vm._s(user.email)+"\n              ")])],1),_vm._v(" "),_c('v-divider',{key:user.email})]})],2)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.onClose}},[_vm._v("\n          Close\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 184 */,
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-carousel',_vm._l((_vm.featuredMeetups),function(meetup,index){return _c('v-carousel-item',{key:index,staticStyle:{"cursor":"pointer"},attrs:{"src":meetup.coverPicURL},nativeOn:{"click":function($event){_vm.onShowDetails(meetup)}}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('h3',{staticClass:"display-1 white--text"},[_vm._v("Welcome to Meetups")])])],1)],1)],1)}))],1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"dense":"","color":"primary","dark":"","extended":"","flat":""}}),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md8":"","offset-md2":""}},[_c('v-card',{staticClass:"card--flex-toolbar",attrs:{"flat":"","color":"transparent"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"white--text"},[_vm._v("Discover Meetups")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.featuredMeetups),function(meetup){return _c('v-flex',{key:meetup.id,attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('meetupCard',{staticStyle:{"cursor":"pointer"},attrs:{"meetup":meetup},nativeOn:{"click":function($event){_vm.onShowDetails(meetup)}}})],1)}))],1)],1)],1)],1)],1),_vm._v(" "),_c('meetupDetails',{attrs:{"dialog":_vm.meetupDetailsDialog,"meetup":_vm.meetup},on:{"close":_vm.closeMeetupDetails}}),_vm._v(" "),_c('v-footer',{attrs:{"height":"auto"}},[_c('v-card',{staticClass:"white--text text-xs-center",staticStyle:{"width":"100%"},attrs:{"flat":"","tile":"","color":"primary"}},[_c('v-card-text',_vm._l((_vm.icons),function(icon){return _c('v-btn',{key:icon,staticClass:"mx-3 white--text",attrs:{"icon":""}},[_c('v-icon',{attrs:{"size":"24px"}},[_vm._v(_vm._s(icon))])],1)})),_vm._v(" "),_c('v-card-text',{staticClass:"white--text pt-0"},[_vm._v("\n        Meet like minded people and make amazing friends.\n      ")]),_vm._v(" "),_c('v-card-text',{staticClass:"white--text"},[_vm._v("\n        ©2018 — "),_c('strong',[_vm._v("Meetups")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_auth_auth__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_auth_profile__ = __webpack_require__(201);



var routes = [{
  path: '/auth',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_auth_auth__["a" /* default */],
  name: 'auth',
  meta: {
    anonymous: true
  }
}, {
  path: '/profile',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_auth_profile__["a" /* default */],
  name: 'profile',
  meta: {
    authenticated: true
  }
}];

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auth_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655c52d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auth_vue__ = __webpack_require__(200);
function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655c52d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signIn_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b86ccad2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signIn_vue__ = __webpack_require__(193);
function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b86ccad2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"flat":"","dense":"","color":_vm.color,"dark":""}},[_c('v-toolbar-title',[_vm._v("\n           "+_vm._s(_vm.title)+"\n         ")])],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n         "+_vm._s(_vm.body)+"\n       ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_vm._l((_vm.buttons),function(button,index){return _c('v-btn',{key:index,attrs:{"color":button.color ? button.color : 'primary',"flat":button.flat},on:{"click":function($event){_vm.onButtonClick(button.action, index)}}},[_c('v-icon',[_vm._v(_vm._s(button.icon ? button.icon : ''))]),_vm._v("\n           "+_vm._s(button.text)+"\n         ")],1)})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-1"},[_c('v-card-title',{attrs:{"align-center":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('h2',[_vm._v("SIGN IN")])])],1),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSignIn($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"e-mail","id":"email","prepend-icon":"email","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"password","id":"password","prepend-icon":"lock","append-icon":_vm.passVisible ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.passVisible = !_vm.passVisible); },"type":_vm.passVisible ? 'text' : 'password',"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"secondary","loading":_vm.loading,"disabled":_vm.loading}},[_vm._v("\n        Sign In\n      ")])],1)],1),_vm._v(" "),_c('popUp',{attrs:{"dialog":_vm.showPopUp,"body":_vm.popUpBody,"title":_vm.popUpTitle,"buttons":_vm.popUpButons,"color":_vm.popUpColor},on:{"okay":_vm.closePopUp,"signInError":_vm.closePopUp}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signUp_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5065c724_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signUp_vue__ = __webpack_require__(196);
function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5065c724_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-1"},[_c('v-card-title',{attrs:{"align-center":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('h2',[_vm._v("SIGN UP")])])],1),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSignUp($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"full-name","label":"full name","id":"fullName","prepend-icon":"person","type":"text","required":""},model:{value:(_vm.fullName),callback:function ($$v) {_vm.fullName=$$v},expression:"fullName"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"e-mail","id":"emailSignUp","prepend-icon":"email","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"password","id":"passwordSignUp","prepend-icon":"lock","append-icon":_vm.passVisible ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.passVisible = !_vm.passVisible); },"type":_vm.passVisible ? 'text' : 'password',"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary"},on:{"click":_vm.onClear}},[_vm._v("\n        clear\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"secondary","loading":_vm.loading,"disabled":_vm.loading}},[_vm._v("\n        Sign Up\n      ")])],1)],1),_vm._v(" "),_c('popUp',{attrs:{"dialog":_vm.showPopUp,"body":_vm.popUpBody,"title":_vm.popUpTitle,"buttons":_vm.popUpButons,"color":_vm.popUpColor},on:{"okay":_vm.closePopUp,"signUpSuccess":_vm.onSignUpSuccess,"signUpError":_vm.closePopUp}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgotPassword_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04bb2d96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgotPassword_vue__ = __webpack_require__(199);
function injectStyle (ssrContext) {
  __webpack_require__(198)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04bb2d96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-1"},[_c('v-card-title',{attrs:{"align-center":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('h2',[_vm._v("RESET PASSWORD")])])],1),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onResetPassword($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"e-mail","id":"emailResetPassword","prepend-icon":"email","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"secondary","loading":_vm.loading,"disabled":_vm.loading}},[_vm._v("\n        Reset\n      ")])],1)],1),_vm._v(" "),_c('pop-up',{attrs:{"dialog":_vm.showPopUp,"body":_vm.popUpBody,"title":_vm.popUpTitle,"buttons":_vm.popUpButons,"color":_vm.popUpColor},on:{"okay":_vm.closePopUp}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"pt-2",attrs:{"color":"primary","dark":"","extended":"","extension-height":"100","flat":""}},[_c('v-toolbar-title',{staticClass:"mx-auto"},[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":{name: 'home'},"tag":"span"}},[_c('v-avatar',[_c('img',{attrs:{"src":__webpack_require__(53),"alt":"meetup_img"}})]),_vm._v("\n      Meetups\n    ")],1)],1)],1),_vm._v(" "),_c('v-container',{staticClass:"card--flex-toolbar"},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('v-card',{attrs:{"elevation-12":""}},[_c('v-tabs',{attrs:{"fixed-tabs":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab',{key:1,attrs:{"ripple":""}},[_vm._v("\n              Sing In\n            ")]),_vm._v(" "),_c('v-tab-item',{key:1},[_c('sign-in',{on:{"signInSuccess":_vm.onSignInSuccess}})],1),_vm._v(" "),_c('v-tab',{key:2,attrs:{"ripple":""}},[_vm._v("\n              Forgot Password\n            ")]),_vm._v(" "),_c('v-tab-item',{key:2},[_c('forgot-password')],1),_vm._v(" "),_c('v-tab',{key:3,attrs:{"ripple":""}},[_vm._v("\n              Sign Up\n            ")]),_vm._v(" "),_c('v-tab-item',{key:3},[_c('sign-up',{on:{"signUpSuccess":_vm.onSignUpSuccess}})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcc35566_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__ = __webpack_require__(205);
function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcc35566_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',[_c('v-text-field',{ref:"fileTextField",attrs:{"prepend-icon":"attach_file","single-line":"","label":_vm.label,"required":_vm.required,"disabled":""},model:{value:(_vm.filename),callback:function ($$v) {_vm.filename=$$v},expression:"filename"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"pink","dark":"","fab":"","small":"","reg":"uploadBtn"},on:{"click":_vm.onFocus}},[_c('v-icon',[_vm._v("file_upload")])],1),_vm._v(" "),_c('input',{ref:"fileInput",staticStyle:{"position":"absolute","display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFileChange}}),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarTimeout,"color":_vm.snackbarColor},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarText)+"\n  "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Dismiss")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('v-card',{attrs:{"elevation-12":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"pl-2",staticStyle:{"text-align":"center"}},[_vm._v("PROFILE")])])],1),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('v-layout',{staticClass:"pa-1",attrs:{"row":"","align-center":""}},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('v-avatar',{staticClass:"primary",attrs:{"size":"80px"}},[(_vm.photoURL)?_c('img',{attrs:{"src":_vm.photoURL}}):_c('v-icon',{attrs:{"dark":"","large":""}},[_vm._v("\n                  person\n                ")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-1",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('FileUpload',{attrs:{"label":"Update Profile Pic","required":false},on:{"uploadFile":_vm.uploadProfilePic}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[(_vm.showUploadProgress)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{attrs:{"rotate":360,"size":42,"indeterminate":_vm.uploadProgress < 100,"value":_vm.uploadProgress,"color":"teal"}},[_vm._v("\n                  "+_vm._s(_vm.uploadProgress+"%")+"\n                ")]),_vm._v(" "),(_vm.uploadProgress < 100)?_c('span',[_vm._v("Uploading")]):_vm._e()],1):_vm._e()])],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-1",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"name","label":"Name","id":"name","prepend-icon":"person","type":"text","required":""},model:{value:(_vm.displayName),callback:function ($$v) {_vm.displayName=$$v},expression:"displayName"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-1",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"Email","id":"email","prepend-icon":"mail","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"secondary","loading":_vm.loading,"disabled":_vm.loading || _vm.disabled}},[_vm._v("\n              Save\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_meetups_meetups__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_meetups_myMeetups__ = __webpack_require__(210);



var routes = [{
  path: '/meetups',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_meetups_meetups__["a" /* default */],
  name: 'meetups'
}, {
  path: '/myMeetups',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_meetups_myMeetups__["a" /* default */],
  name: 'myMeetups'
}];

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_meetups_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17e56c72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_meetups_vue__ = __webpack_require__(209);
function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_meetups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17e56c72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_meetups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.totalMeetups === 0)?_c('h3',[_vm._v("\n    No Meetups at the moment...\n  ")]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md3":"","lg3":""}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.meetups),function(meetup){return _c('v-flex',{key:meetup.id,attrs:{"xs12":"","sm4":"","md3":"","lg3":""}},[_c('meetupCard',{staticStyle:{"cursor":"pointer"},attrs:{"meetup":meetup},nativeOn:{"click":function($event){_vm.onShowDetails(meetup)}}})],1)})),_vm._v(" "),_c('meetupDetails',{attrs:{"dialog":_vm.meetupDetailsDialog,"meetup":_vm.meetup},on:{"close":_vm.closeMeetupDetails}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myMeetups_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a863867_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myMeetups_vue__ = __webpack_require__(218);
function injectStyle (ssrContext) {
  __webpack_require__(211)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myMeetups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a863867_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myMeetups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createEditMeetup_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0bc80e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createEditMeetup_vue__ = __webpack_require__(214);
function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createEditMeetup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0bc80e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createEditMeetup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","overlay":true},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary","fixed":""}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.onClose($event)}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Create Meetup")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-container',{staticStyle:{"margin-top":"50px"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('v-card',{attrs:{"elevation-12":""}},[(_vm.meetup.coverPicURL)?_c('v-card-media',{attrs:{"src":_vm.meetup.coverPicURL,"height":"200px"}}):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('v-layout',{staticClass:"pa-1",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"title","label":"Title","id":"title","prepend-icon":"title","type":"text","required":""},model:{value:(_vm.meetup.title),callback:function ($$v) {_vm.$set(_vm.meetup, "title", $$v)},expression:"meetup.title"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-1",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('FileUpload',{attrs:{"label":"Cover Pic","required":false},on:{"uploadFile":_vm.uploadCover}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[(_vm.showUploadProgress)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{attrs:{"rotate":360,"size":42,"indeterminate":_vm.uploadProgress < 100,"value":_vm.uploadProgress,"color":"teal"}},[_vm._v("\n                      "+_vm._s(_vm.uploadProgress+"%")+"\n                    ")]),_vm._v(" "),(_vm.uploadProgress < 100)?_c('span',[_vm._v("Uploading")]):_vm._e()],1):_vm._e()])],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-1",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"name":"category","label":"Category","id":"description","items":_vm.categories,"prepend-icon":"category","required":"","autocomplete":""},model:{value:(_vm.meetup.category),callback:function ($$v) {_vm.$set(_vm.meetup, "category", $$v)},expression:"meetup.category"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-1",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","prepend-icon":"description","type":"text","multi-line":"","required":""},model:{value:(_vm.meetup.description),callback:function ($$v) {_vm.$set(_vm.meetup, "description", $$v)},expression:"meetup.description"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-1",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"location","label":"Location","id":"location","prepend-icon":"location_on","type":"text","required":""},model:{value:(_vm.meetup.location),callback:function ($$v) {_vm.$set(_vm.meetup, "location", $$v)},expression:"meetup.location"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-1",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-menu',{ref:"dateDialog",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.meetup.date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.$set(_vm.meetup, "date", $event)}},model:{value:(_vm.dateDialog),callback:function ($$v) {_vm.dateDialog=$$v},expression:"dateDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":"","required":""},slot:"activator",model:{value:(_vm.meetup.date),callback:function ($$v) {_vm.$set(_vm.meetup, "date", $$v)},expression:"meetup.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.$refs.dateDialog.save(_vm.meetup.date)}},model:{value:(_vm.meetup.date),callback:function ($$v) {_vm.$set(_vm.meetup, "date", $$v)},expression:"meetup.date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-menu',{ref:"timeDialog",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.meetup.time,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){_vm.$set(_vm.meetup, "time", $event)}},model:{value:(_vm.timeDialog),callback:function ($$v) {_vm.timeDialog=$$v},expression:"timeDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Time","prepend-icon":"access_time","readonly":"","required":""},slot:"activator",model:{value:(_vm.meetup.time),callback:function ($$v) {_vm.$set(_vm.meetup, "time", $$v)},expression:"meetup.time"}}),_vm._v(" "),(_vm.timeDialog)?_c('v-time-picker',{attrs:{"format":"24hr"},on:{"change":function($event){_vm.$refs.timeDialog.save(_vm.meetup.time)}},model:{value:(_vm.meetup.time),callback:function ($$v) {_vm.$set(_vm.meetup, "time", $$v)},expression:"meetup.time"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"secondary","loading":_vm.loading,"disabled":_vm.loading || _vm.disabled || _vm.incomplete}},[_vm._v("\n                  "+_vm._s(_vm.submitBtnText)+"\n                ")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myMeetupCard_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdfff476_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myMeetupCard_vue__ = __webpack_require__(217);
function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myMeetupCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdfff476_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myMeetupCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-2"},[_c('v-card-media',{class:_vm.color,attrs:{"src":_vm.meetup.coverPicURL,"height":"125px"}}),_vm._v(" "),_c('v-card-title',{staticClass:"pb-0 pt-1",attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-2 text--ellipsisTwoLines"},[_vm._v(_vm._s(_vm.meetup.title))]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Date: ")]),_vm._v(_vm._s(_vm.meetup.date)+"\n      ")]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Location: ")]),_vm._v(_vm._s(_vm.meetup.location)+"\n      ")])])]),_vm._v(" "),_c('v-card-text',{staticClass:"pa-1"},[_c('v-list',{staticClass:"pt-0",attrs:{"three-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("\n          "+_vm._s(_vm.meetup.description)+"\n        ")])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},on:{"click":_vm.onDelete}},[_vm._v("\n      DELETE\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.onEdit}},[_vm._v("\n      EDIT\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.totalMeetups === 0)?_c('h3',[_vm._v("\n    Click on the + (create) icon at the bottom to create Meetup.\n  ")]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.myMeetups),function(meetup){return _c('v-flex',{key:meetup.id,attrs:{"xs12":"","sm4":"","md3":"","lg3":""}},[_c('myMeetupCard',{attrs:{"meetup":meetup},on:{"onDelete":_vm.onDeleteMeetup,"onEdit":_vm.onEdit}})],1)})),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"secondary","dark":"","fab":"","fixed":"","bottom":"","right":"","small":""},on:{"click":function($event){_vm.showCreateEditDialog('Create')}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("create")])],1),_vm._v(" "),_c('createEditMeetup',{attrs:{"dialog":_vm.createEditDialog,"mode":_vm.createEditDialogMode,"loading":_vm.loading,"meetup":_vm.meetup},on:{"updateMeetup":_vm.updateMeetup,"createMeetup":_vm.createMeetup,"close":_vm.closeCreateEditDialog}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meetups__ = __webpack_require__(242);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */],
    meetups: __WEBPACK_IMPORTED_MODULE_3__meetups__["a" /* default */]
  },
  strict: debug
}));

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(241);




var state = {
  user: null
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */]
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__firebase_app__);





function buildUserObject(userData) {
  var user = {};
  user.displayName = userData.displayName ? userData.displayName : '';
  user.email = userData.email ? userData.email : '';
  user.phoneNumber = userData.phoneNumber ? userData.phoneNumber : '';
  user.photoURL = userData.photoURL ? userData.photoURL : '';
  user.id = userData.uid;
  return user;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createNewUser: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, payload) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;
      var newUser, user;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__firebase_app___default.a.auth().createUserWithEmailAndPassword(payload.email, payload.password);

            case 3:
              newUser = _context.sent;

              // console.log(newUser)
              user = newUser.user;
              _context.next = 7;
              return user.updateProfile({
                displayName: payload.fullName
              });

            case 7:
              _context.next = 9;
              return user.sendEmailVerification();

            case 9:
              dispatch('signOutUser');
              return _context.abrupt('return', user);

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](0);

              dispatch('signOutUser');
              throw _context.t0;

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 13]]);
    }));

    function createNewUser(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return createNewUser;
  }(),
  signInUser: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref4, payload) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var _this = this;

                __WEBPACK_IMPORTED_MODULE_3__firebase_app___default.a.auth().signInWithEmailAndPassword(payload.email, payload.password).then(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(user) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(user.user.emailVerified === false)) {
                              _context2.next = 5;
                              break;
                            }

                            user.user.sendEmailVerification();
                            dispatch('signOutUser');
                            reject(new Error('A verification link has been sent to your email address. please verify your email before signing in.'));
                            return _context2.abrupt('return');

                          case 5:
                            // dispatch('sendTokenToServer', {
                            //   status: true,
                            //   userId: user.user.uid
                            // })
                            commit('SET_USER', buildUserObject(user.user));
                            resolve(user.user);

                          case 7:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this);
                  }));

                  return function (_x5) {
                    return _ref5.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function signInUser(_x3, _x4) {
      return _ref3.apply(this, arguments);
    }

    return signInUser;
  }(),
  autoSignIn: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(_ref7) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;
      var user;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              user = __WEBPACK_IMPORTED_MODULE_3__firebase_app___default.a.auth().currentUser;
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
                var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(resolve, reject) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          if (user) {
                            // dispatch('sendTokenToServer', {
                            //   status: true,
                            //   userId: user.uid
                            // })
                            resolve(user);
                            commit('SET_USER', buildUserObject(user));
                          } else {
                            reject(Error('no signed in user found'));
                          }

                        case 1:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _callee4, this);
                }));

                return function (_x7, _x8) {
                  return _ref8.apply(this, arguments);
                };
              }()));

            case 2:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function autoSignIn(_x6) {
      return _ref6.apply(this, arguments);
    }

    return autoSignIn;
  }(),
  signOutUser: function signOutUser(_ref9) {
    var commit = _ref9.commit;

    // console.log('called signOutUser.')
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__firebase_app___default.a.auth().signOut().then(function (res) {
        commit('SET_USER', null);
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  sendPasswordResetLink: function sendPasswordResetLink(_ref10, payload) {
    var commit = _ref10.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__firebase_app___default.a.auth().sendPasswordResetEmail(payload.email).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateUserProfile: function () {
    var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(_ref12, payload) {
      var commit = _ref12.commit;
      var user;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              console.log('called updateUserProfile: ', payload);
              user = __WEBPACK_IMPORTED_MODULE_3__firebase_app___default.a.auth().currentUser;
              return _context6.abrupt('return', user.updateProfile({
                displayName: payload.displayName,
                photoURL: payload.photoUrl
              }).then(function () {
                return user.updateEmail(payload.email);
              }).catch(function (error) {
                return error;
              }));

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function updateUserProfile(_x9, _x10) {
      return _ref11.apply(this, arguments);
    }

    return updateUserProfile;
  }()
});

/***/ }),
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = ({
  getUser: function getUser(state) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.user);
  },
  isAuthenticated: function isAuthenticated(state) {
    return state.user ? !!state.user.id : false; // !== null && state.user !== undefined
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_USER: function SET_USER(state, payload) {
    state.user = payload;
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(247);




var state = {
  coverPicProgress: 0,
  myMeetups: {},
  meetups: {},
  categories: ['Sports & Fitness', 'Health & Wellness', 'Technology', 'Outdoor & Adventure', 'Music', 'Spirituality', 'Fashion & Beauty', 'Arts', 'Film', 'Writing', 'Other']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */]
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__firebase_app__);







/* harmony default export */ __webpack_exports__["a"] = ({
  createNewMeetup: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, meetup) {
      var getters = _ref2.getters;
      var user, meetupsCollection, ref, id, newMeetup;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // console.log('called createNewMeetup: ', meetup)
              user = getters.getUser;
              meetupsCollection = __WEBPACK_IMPORTED_MODULE_5__firebase_app___default.a.firestore().collection('meetups');
              ref = meetupsCollection.doc();
              id = ref.id;
              newMeetup = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(meetup, {
                id: id,
                user: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, user),
                created: __WEBPACK_IMPORTED_MODULE_5__firebase_app___default.a.firestore.FieldValue.serverTimestamp()
              });
              return _context.abrupt('return', meetupsCollection.doc(id).set(newMeetup));

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function createNewMeetup(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return createNewMeetup;
  }(),
  updateExistingMeetup: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, meetup) {
      var commit = _ref4.commit;
      var meetupsCollection;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // console.log('called updateMeetup action: ', meetup)
              meetupsCollection = __WEBPACK_IMPORTED_MODULE_5__firebase_app___default.a.firestore().collection('meetups');
              return _context2.abrupt('return', meetupsCollection.doc(meetup.id).set(meetup));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function updateExistingMeetup(_x3, _x4) {
      return _ref3.apply(this, arguments);
    }

    return updateExistingMeetup;
  }(),
  deleteMeetup: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, meetup) {
      var commit = _ref6.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__firebase_app___default.a.firestore().collection('meetups').doc('' + meetup.id).delete());

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function deleteMeetup(_x5, _x6) {
      return _ref5.apply(this, arguments);
    }

    return deleteMeetup;
  }(),
  fetchMyMeetups: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref8) {
      var getters = _ref8.getters,
          commit = _ref8.commit;
      var user, db, citiesRef, query;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // console.log('called fetchMyMeetps')
              user = getters.getUser;
              db = __WEBPACK_IMPORTED_MODULE_5__firebase_app___default.a.firestore();
              citiesRef = db.collection('meetups');

              // Create a query against the collection.

              query = citiesRef.where('user.id', '==', user.id);

              query.onSnapshot(function (querySnapshot) {
                var myMeetups = {};
                querySnapshot.forEach(function (doc) {
                  var meetup = doc.data();
                  myMeetups[meetup.id] = meetup;
                });
                // console.log('myMeetups: ', myMeetups)
                commit('SET_MY_MEETUPS', myMeetups);
              });

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function fetchMyMeetups(_x7) {
      return _ref7.apply(this, arguments);
    }

    return fetchMyMeetups;
  }(),
  fetchAllMeetups: function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(_ref10) {
      var commit = _ref10.commit;
      var db, meetupRef;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              // console.log('called fetchAllMeetups')
              db = __WEBPACK_IMPORTED_MODULE_5__firebase_app___default.a.firestore();
              meetupRef = db.collection('meetups');

              meetupRef.onSnapshot(function (querySnapshot) {
                var meetups = {};
                querySnapshot.forEach(function (doc) {
                  var meetup = doc.data();
                  meetups[meetup.id] = meetup;
                });
                // console.log('meetups: ', meetups)
                commit('SET_MEETUPS', meetups);
              });

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function fetchAllMeetups(_x8) {
      return _ref9.apply(this, arguments);
    }

    return fetchAllMeetups;
  }(),
  updateGoingStatus: function () {
    var _ref11 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(_ref12, payload) {
      var getters = _ref12.getters;
      var meetup, status, user, db, docRef;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              meetup = payload.meetup;
              status = payload.status;
              user = getters.getUser;
              db = __WEBPACK_IMPORTED_MODULE_5__firebase_app___default.a.firestore();
              docRef = db.collection('meetups/' + meetup.id + '/going').doc('' + user.id);

              if (!status) {
                _context6.next = 9;
                break;
              }

              return _context6.abrupt('return', docRef.set(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ going: true }, user)));

            case 9:
              return _context6.abrupt('return', docRef.delete());

            case 10:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function updateGoingStatus(_x9, _x10) {
      return _ref11.apply(this, arguments);
    }

    return updateGoingStatus;
  }(),
  isGoing: function isGoing(_ref13, meetup) {
    var getters = _ref13.getters;

    var user = getters.getUser;
    var db = __WEBPACK_IMPORTED_MODULE_5__firebase_app___default.a.firestore();
    var docRef = db.collection('meetups/' + meetup.id + '/going').doc('' + user.id);
    return docRef.get().then(function (doc) {
      if (doc.exists) {
        return true;
      } else {
        return false;
      }
    });
  },
  fetchAllGoingUsers: function () {
    var _ref14 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(_ref15, meetup) {
      var commit = _ref15.commit;
      var db, goingRef;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              db = __WEBPACK_IMPORTED_MODULE_5__firebase_app___default.a.firestore();
              goingRef = db.collection('meetups/' + meetup.id + '/going');
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                goingRef.onSnapshot(function (querySnapshot) {
                  var users = {};
                  querySnapshot.forEach(function (doc) {
                    var user = doc.data();
                    users[user.id] = user;
                  });
                  // console.log('users: ', users)
                  resolve(users);
                  return users;
                });
              }));

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function fetchAllGoingUsers(_x11, _x12) {
      return _ref14.apply(this, arguments);
    }

    return fetchAllGoingUsers;
  }()
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  getCoverPicProgress: function getCoverPicProgress(state) {
    return state.coverPicProgress;
  },
  getMyMeetups: function getMyMeetups(state) {
    return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.myMeetups));
  },
  getMeetups: function getMeetups(state) {
    return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.meetups));
  },
  getMeetupCategories: function getMeetupCategories(state) {
    return state.categories;
  }
});

/***/ }),
/* 245 */,
/* 246 */,
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_COVER_PIC_PROGRESS: function SET_COVER_PIC_PROGRESS(state, payload) {
    state.coverPicProgress = payload;
  },
  SET_MY_MEETUPS: function SET_MY_MEETUPS(state, payload) {
    state.myMeetups = payload;
  },
  SET_MEETUPS: function SET_MEETUPS(state, payload) {
    state.meetups = payload;
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
var config = {
  apiKey: 'AIzaSyBdK2WUl8SSZCofCF5peKATO-qN469jKIc',
  authDomain: 'meetups-e7599.firebaseapp.com',
  databaseURL: 'https://meetups-e7599.firebaseio.com',
  projectId: 'meetups-e7599',
  storageBucket: 'meetups-e7599.appspot.com',
  messagingSenderId: '351354889583'
};

/***/ }),
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */,
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */,
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */,
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */,
/* 286 */,
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */,
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */,
/* 326 */,
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */,
/* 339 */,
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */,
/* 343 */,
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */,
/* 354 */,
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */,
/* 357 */,
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]),[138]);


// WEBPACK FOOTER //
// static/js/app.78ca272fa8eee6c27fb5.js